export default __webpack_public_path__ + "static/media/13-Nahlah-Alhorayess.11ed02ff.png";